// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"styles_cardTitle__2NGo7"};